import React from 'react';
import { Link } from 'react-router-dom';
import DefaultCard from '../../../../components/default/DefaultCard';
import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import UsageBar from '../../components/UsageBar';
import { formatDate, WHITE_LABEL_LABELS } from '../../types';
import { OrganizationContextProps } from '../index';

const SummaryTab: React.FC<OrganizationContextProps> = ({ organization, membership, plan, goToTab }) => {
    const isFirm = organization.organization_type === 'firm';
    const subscription = plan.subscription;

    return (
        <div className="row">
            <div className="col-lg-7 mb-3">
                <DefaultCard>
                    <h5 className="mb-3">Uso de tu plan</h5>
                    <UsageBar label={isFirm ? 'Usuarios (incluye invitaciones pendientes)' : 'Usuarios'}
                              used={plan.usage.seats} limit={plan.limits.max_seats} />
                    <UsageBar label="Clientes en cartera" used={plan.usage.clients} limit={plan.limits.max_clients} />
                    <UsageBar label="Solicitudes de marca en curso" used={plan.usage.brand_applications}
                              limit={plan.limits.max_brand_applications} />
                    <div className="d-flex flex-wrap gap-2 mt-3">
                        <Link to="/intranet/clients" className="btn btn-sm btn-outline-primary">
                            <i className="fas fa-address-book me-1" /> Ir a mi cartera
                        </Link>
                        {isFirm && (
                            <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => goToTab('team')}>
                                <i className="fas fa-user-plus me-1" /> Gestionar equipo
                            </button>
                        )}
                    </div>
                </DefaultCard>
            </div>
            <div className="col-lg-5 mb-3">
                <DefaultCard>
                    <h5 className="mb-1">Plan {plan.plan?.name || '—'}</h5>
                    <p className="text-muted small mb-3">
                        {plan.is_fallback
                            ? 'Sin suscripción vigente: aplican los límites del plan gratuito.'
                            : subscription?.is_manual_assignment
                                ? 'Plan asignado por Monere.'
                                : subscription?.is_subscription
                                    ? 'Cobro mensual automático con Flow.'
                                    : 'Plan gratuito.'}
                    </p>
                    <ul className="list-unstyled small mb-3">
                        <li className="mb-1"><i className="fas fa-palette me-2 text-muted" />Marca: {WHITE_LABEL_LABELS[plan.limits.white_label_level]}</li>
                        {subscription?.end_date && (
                            <li className="mb-1"><i className="fas fa-calendar me-2 text-muted" />Vigente hasta: {formatDate(subscription.end_date)}</li>
                        )}
                        {subscription?.next_invoice_date && (
                            <li className="mb-1"><i className="fas fa-receipt me-2 text-muted" />Próximo cobro: {formatDate(subscription.next_invoice_date)}</li>
                        )}
                    </ul>
                    {membership.is_admin && (
                        <ButtonGeneral
                            onClick={() => goToTab('subscription')}
                            title="Ver planes"
                            icon="fa-arrow-up"
                            size="small"
                        />
                    )}
                </DefaultCard>
            </div>
        </div>
    );
};

export default SummaryTab;
